// Shares installation scripts and restoration guidance while each caller owns copying.

import { Copy } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { HighlightedMarkup } from '../embed/HighlightedMarkup'
import type { WidgetInstallSectionProps } from './WidgetInstallSection.types'

export function WidgetInstallSection({
  entries,
  title,
  copyLabel,
  onCopy,
  copied,
}: WidgetInstallSectionProps) {
  return (
    <div className="space-y-3">
      <div className="space-y-1.5">
        <h3 className="text-base font-semibold text-foreground">{title}</h3>
        <p className="text-sm text-muted-foreground">
          Add each complete script to your sitewide template or tag manager. The
          widget creates its own launcher and panel. No chat container is
          required.
        </p>
      </div>
      {entries.map((entry) => (
        <div
          key={entry.id}
          className="overflow-hidden rounded-2xl border border-primary"
        >
          {entry.name && (
            <p className="px-5 pt-3 text-sm font-medium">{entry.name}</p>
          )}
          <div className="bg-gray-900 p-5">
            <HighlightedMarkup markup={entry.script} />
          </div>
          <Button
            type="button"
            className="h-9 w-full rounded-none"
            onClick={() => onCopy(entry.script)}
          >
            <Copy className="h-4 w-4" />
            {copied ? 'Copied!' : copyLabel}
          </Button>
        </div>
      ))}
      <p className="text-sm text-muted-foreground">
        Each origin keeps its own conversation. Shop and checkout subdomains do
        not share history.
      </p>
      <p className="text-sm text-muted-foreground">
        Persistence requires eligible consent. Visitors awaiting consent start a
        new conversation after full-page navigation.
      </p>
      <p className="text-sm text-muted-foreground">
        Navigation can interrupt an answer. Completed history returns, and Ask
        again submits a new message when an answer is missing.
      </p>
    </div>
  )
}
